<template>
  <div class="container-fluid" style="padding-left: 0px; padding-right: 0px;">
    <div class="pageContainer">
      <div class="row">
        <div class="col-lg-9">
          <div class="pageSubContainer">
            <div class="row">
              <div class="col-sm-12">
                <div class="pageCard">
                  <div class="row">
                    <div class="col-sm-12">
                     <h4 class="reference">Job Report</h4>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <hr />
                    </div>
                  </div>
                  <form @submit.prevent="updateOrder">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="itemsGroup">
                          
                          <div class="itemsList">
                            <dt class="item">Invoice Address</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select>
                                  <option v-for="address in addresses" :key="address.id" :value="address.id" :selected="address.id === order.invoice_address_id">{{ address.address1 }}, {{ address.address2 }}, {{ address.city }}, {{ address.county }}, {{ address.postcode }}</option>
                                </select>
                              </div>
                            </dd>
                          </div>
                          <div class="itemsList">
                            <dt class="item">Site Address</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select v-model="order.site_address_id">
                                  <option v-for="address in addresses" :key="address.id" :value="address.id" :selected="address.id === order.site_address_id">{{ address.address1 }}, {{ address.address2 }}, {{ address.city }}, {{ address.county }}, {{ address.postcode }}</option>
                                </select>
                              </div>
                            </dd>
                          </div>
                          <div class="itemsList">
                            <dt class="item">Asset</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select  v-model="order.asset_id">
                                  <option v-for="asset in assets" :key="asset.id" :value="asset.id" :selected="asset.id === order.asset_id">({{ asset.serial }}) {{ asset.name }}</option>
                                </select>
                              </div>
                            </dd>
                          </div>
                          <div class="itemsList">
                            <dt class="item">Engineer</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select v-model="order.engineer">
                                  <option value="Will Rae">Will Rae</option>
                                  <option value="Ben White">Ben White</option>
                                  
                                </select>
                              </div>
                            </dd>
                          </div>
                        </div>
                      </div>
                        <div class="col-sm-6">
        
                          <div class="itemsGroup">
                            <div class="itemsList">
                            <dt class="item">Contact</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select>
                                  <option v-for="contact in contacts" :key="contact.id" :value="contact.id" :selected="contact.id === order.contact_id">{{ contact.first_name }} {{ contact.last_name }}</option>
                                </select>
                              </div>
                            </dd>
                          </div>
                            <div class="itemsList">
                              <dt class="item">Reference</dt>
                              <dd class="item"><input type="text" class="text" v-model="order.customer_reference" /></dd>
                            </div>
                            <div class="itemsList">
                              <dt class="item">Customer PO</dt>
                              <dd class="item"><input type="text" class="text" v-model="order.customer_po" /></dd>
                            </div>
                            <div class="itemsList">
                              <dt class="item">Xero Invoice Number</dt>
                              <dd class="item"><input type="text" class="text" v-model="order.xero_invoice_number" /></dd>
                            </div>
                            
                          </div>
                        </div>
                      <div class="col-sm-4">
                        
                      </div>
                    </div>
                    

                    <div class="row">
                      <div class="col-lg-2">
                        <label style="text-align:left;">Job Description</label>
                      </div>
                      <div class="col-lg-10">
                        <textarea v-model="order.job_description" rows="5" placeholder="Job Description"></textarea>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-12">
                        <hr />
                      </div>
                    </div>


                    <div class="row">
                      <div class="col-lg-2">
                        <label style="text-align:left;">Engineers Report</label>
                      </div>
                      <div class="col-lg-10">
                        <textarea v-model="order.engineers_report" rows="15" placeholder="Engineers report"></textarea>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-2">
                        <label style="text-align:left;">Further Work Required</label>
                      </div>
                      <div class="col-lg-10">
                        <textarea v-model="order.futher_work" rows="5" placeholder="Futher work"></textarea>
                      </div>
                    </div>
                    
                    <div class="row">
                    <div class="col-sm-12">
                      <hr />
                    </div>
                  </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="col-lg-2">
                            <label style="text-align:left;">Materials Used</label>
                          </div>
                          <div class="col-lg-10">
                            <textarea v-model="order.materials_used" rows="5" placeholder="Materials used"></textarea>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="col-lg-2">
                            <label style="text-align:left;">Parts Required</label>
                          </div>
                          <div class="col-lg-10">
                            <textarea v-model="order.parts_required" rows="5" placeholder="Any parts required"></textarea>
                          </div>
                        </div>

                      </div>
                      
                    </div>
                    <div class="row">
                    <div class="col-sm-12">
                      <hr />
                    </div>
                  </div>

                  <div class="row">
                      <div class="col-sm-3">
                        <div class="row">
                          <div class="col-sm-4">
                            <label style="text-align:left;">Hours</label>
                          </div>
                          <div class="col-sm-8">
                            <input type="text" class="text" v-model="order.hours" />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="row">
                          <div class="col-sm-4">
                            <label style="text-align:left;">Mileage</label>
                          </div>
                          <div class="col-sm-8">
                            <input type="text" class="text" v-model="order.mileage" />
                          </div>
                        </div>

                      </div>
                      
                    </div>

                    <div class="row">
                    <div class="col-sm-12">
                      <hr />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-12">
                      <h6>Customer Completion</h6>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <hr />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12">
                      <div class="row" v-if="order.signature_image">
                        <div class="col-sm-1">Name</div>
                        <div class="col-sm-4">
                          {{ order.signature_name }}
                        </div>
                        <div class="col-sm-1">Signture</div>
                        <div class="col-sm-6">
                          <img :src="order.signature_image" width="50%" />
                        </div>

                      </div>
                      <div class="row" v-else>
                        <div class="col-sm-1">Name</div>
                        <div class="col-sm-4">
                          <input type="text" class="text" v-model="order.signature_name" />
                        </div>
                        <div class="col-sm-1">Signture</div>
                        <div class="col-sm-6">
                          <VueSignaturePad width="100%" height="200px" ref="signaturePad" style="border: 1px solid #c6c6c6;" />
                          <a class="btnRedText" @click.prevent="undoSignature()">Clear</a>
                        </div>

              
                      </div>
                    </div>
                    <!--
                    <div class="col-lg-6">
                      <div class="row" v-if="order.engineer_signature_image">
                        <div class="col-sm-2">Name</div>
                        <div class="col-sm-4">
                          {{ order.engineer }}
                        </div>
                        <div class="col-sm-2">Signture</div>
                        <div class="col-sm-4">
                          <img :src="order.engineer_signature_image" width="100%" />
                        </div>

                      </div>
                      <div class="row" v-else>
                        <div class="col-sm-2">Engineer</div>
                        <div class="col-sm-4">
                          {{ order.engineer }}
                        </div>
                        <div class="col-sm-2">Signture</div>
                        <div class="col-sm-4">-->
                          <!--<VueSignaturePad width="100%" height="100px" ref="signaturePadEngineer" style="border: 1px solid #c6c6c6;" />-->
                        <!--</div>

              
                      </div>
                    </div>-->
                  </div>
                    
                    
                    

                    <div class="row">
                      <div class="col-sm-4">
                         
                      </div>
                      
                      <div class="col-sm-8">
                        <div align="right">
                          <input type="submit" value="Save Job">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                         <a @click.prevent="deleteJob()" class="btnRedText">Delete Job</a>
                      </div>
                      
                      <div class="col-sm-8">
                        
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="pageSubContainer">
            <div class="row">
              <div class="col-sm-12">
                <div class="pageCard greenTop">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>Images</h6>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <form @submit.prevent="submitImage">
                        
                        <input
                          id="image"
                          type="file"
                          accept="image/*"
                          @change="handleFileUpload"
                        />
                      

                      <button type="submit" :disabled="uploading">
                        {{ uploading ? 'Uploading...' : 'Upload' }}
                      </button>
                      </form>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <p v-if="imagesLoading" class="jobImagesNote">Loading images...</p>
                      <p v-else-if="imagesError" class="jobImagesNote">{{ imagesError }} <a href="#" @click.prevent="loadImages">Try again</a></p>
                      <p v-else-if="!jobImages.length" class="jobImagesNote">No images uploaded for this job yet.</p>
                      <div v-else class="jobImages">
                        <a
                          v-for="img in jobImages"
                          :key="img.id"
                          :href="img.url || img.webUrl"
                          target="_blank"
                          rel="noopener"
                          class="jobImage"
                          :title="img.name"
                        >
                          <img v-if="img.thumbnail" :src="img.thumbnail" :alt="img.name" loading="lazy" />
                          <span v-else>{{ img.name }}</span>
                          <small>{{ img.uploaded | formatDate }}</small>
                        </a>
                      </div>
                    </div>
                  </div>
                  
                </div>


                <div class="pageCard greenTop">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>Reports</h6>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <!--<a class="btnOrderAction" @click.prevent="finaliseOrder()">Finalise <font-awesome-icon icon="angle-double-right" /></a>-->
                      <a href="#" @click.prevent="$openPdf('job-report', order.id)" class="btnOrderAction">Job Report <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                  </div>
                  
                </div>
                <div class="pageCard greenTop">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>Method Statement</h6>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <!--<a class="btnOrderAction" @click.prevent="finaliseOrder()">Finalise <font-awesome-icon icon="angle-double-right" /></a>-->
                      <a class="btnOrderAction" target="_blank" >Create <font-awesome-icon icon="angle-double-right" /></a>
                      <!--<a :href="'http://localhost:8000/pdf/method-statement/' + order.id" class="btnOrderAction" target="_blank" >View <font-awesome-icon icon="angle-double-right" /></a>-->
                    </div>
                  </div>
                  
                </div>
                
                <div v-if="order.asset_id">
                <div class="pageCard greenTop">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>F-Gas Leak Check</h6>
                    </div>
                  </div>
                  <div v-if="leak_check_view">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="itemsGroup">
                            <div class="itemsList">
                              <dt class="item">Test Result</dt>
                              <dd class="item"><input type="text" class="text" v-model="leakcheck.result" /></dd>
                            </div>
                            <div class="itemsList">
                              <dt class="item">Further Actions</dt>
                              <dd class="item"><input type="text" class="text" v-model="leakcheck.further" /></dd>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <a @click.prevent="leakTest()" class="btnOrderAction">Process <font-awesome-icon icon="angle-double-right" /></a>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="row">
                      <div class="col-sm-12">
                        <p>I have performed an F-Gas Leak Check in accordance of EU 517/2014.</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <a @click.prevent="goLeakTest()" class="btnGreenLine" >Create Leak Check <font-awesome-icon icon="angle-double-right" /></a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="pageCard greenTop">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>F-Gas Movements</h6>
                    </div>
                  </div>
                  <div v-if="addgas">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="itemsGroup">
                            <div class="itemsList">
                              <dt class="item">Amount added (Kg)</dt>
                              <dd class="item"><input type="text" class="text" v-model="fgasadd.amount_gas" /></dd>
                            </div>
                            <div class="itemsList">
                              <dt class="item">Reason for</dt>
                              <dd class="item"><input type="text" class="text" v-model="fgasadd.reason" /></dd>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" style="margin-bottom: 15px;">
                      <div class="col-sm-12">
                        <a @click.prevent="addGas()" class="btnOrderAction">Process <font-awesome-icon icon="angle-double-right" /></a>
                      </div>
                    </div>
                  </div>
                  <div v-if="removegas">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="itemsGroup">
                            <div class="itemsList">
                              <dt class="item">Amount removed (Kg)</dt>
                              <dd class="item"><input type="text" class="text" v-model="fgasremove.amount_gas" /></dd>
                            </div>
                            <div class="itemsList">
                              <dt class="item">Reason for</dt>
                              <dd class="item"><input type="text" class="text" v-model="fgasremove.reason" /></dd>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" style="margin-bottom: 15px;">
                      <div class="col-sm-12">
                        <a @click.prevent="removeGas()" class="btnOrderAction">Process <font-awesome-icon icon="angle-double-right" /></a>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <a class="btnGreenLine" @click.prevent="goAddGas()" >Add Gas <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                    <div class="col-sm-6">
                      <a class="btnGreenLine" @click.prevent="goRemoveGas()" >Remove Gas <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                  </div>
                </div>
                </div>
              

                <div class="pageCard greenTop" v-if="order.status==='further'">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>Complete Further Works</h6>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <a @click.prevent="completeOrder()" class="btnOrderAction" target="_blank" >Complete Job <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                  </div>
                </div>

                <div class="pageCard greenTop" v-if="!order.invoice_status">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>Invoice Job</h6>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <a @click.prevent="invoiceOrder()" class="btnOrderAction" target="_blank" >Invoice Job <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import axios from 'axios'

export default {
  components: { /*DatePicker*/ },
  data () {
    return {
      order: [],
      contacts: [],
      addresses: [],
      assets: [],
      leak_check_view: false,
      leakcheck: {},
      addgas: false,
      removegas: false,
      fgasadd: {},
      fgasremove: {},
      image: null,
      uploading: false,
      jobImages: [],
      imagesLoading: false,
      imagesError: ''
    }
  },
  watch: {
    productInput (after, before) {
      if (after === null || before === null) {
        this.DoNothing()
      } else {
        this.searchProduct()
      }
    }
  },
  created () {
    axios
      .get(`/api/orders/${this.$route.params.id}`)
      .then((res) => {
        this.order = res.data.order
        this.loadImages()
        axios
          .get(`/api/companies/${this.order.company_id}/contacts`)
          .then(response => {
            this.contacts = response.data
          })
        axios
          .get(`/api/companies/${this.order.company_id}/addresses`)
          .then(response => {
            this.addresses = response.data
          })
        axios
          .get(`/api/companies/${this.order.company_id}/assets`)
          .then(response => {
            this.assets = response.data
          })
      })
    
  },
  methods: {
    onFocus: function () {
      this.isVisible = true
      this.searchProduct()
    },
    onBlur: function () {
      // this.isVisible = false
    },
    handleFileUpload(event) {
      this.image = event.target.files[0]
    },

    async loadImages () {
      this.imagesLoading = true
      this.imagesError = ''

      try {
        const { data } = await axios.get(`/api/orders/${this.$route.params.id}/images`)
        this.jobImages = data.data
      } catch (error) {
        this.imagesError = 'Could not load images from SharePoint.'
        console.error(error)
      } finally {
        this.imagesLoading = false
      }
    },

    async submitImage() {
      if (!this.image) {
        this.message = 'Please select an image first.'
        return
      }

      const formData = new FormData()
      formData.append('file', this.image)
      formData.append('job_number', this.order.order_number)

      this.uploading = true
      this.message = ''

      try {
        await axios.post('/api/sharepoint/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        this.$toast.success("Image uploaded successfully", {})
        this.message = 'Image uploaded successfully.'
        this.image = null
        this.loadImages()
      } catch (error) {
        const reason = error.response && error.response.data && (error.response.data.error || error.response.data.message)
        this.$toast.error("Image failed", {})
        this.message = reason ? `Upload failed: ${reason}` : 'Upload failed.'
        console.error(error)
      } finally {
        this.uploading = false
      }
    },

    goLeakTest () {
      this.leak_check_view = true
    },
    leakTest () {

      this.leakcheck.asset_id = this.order.asset_id
      this.leakcheck.engineer = this.order.engineer
      this.leakcheck.type = 'Leak Check'

      axios
        .post('/api/fgas', this.leakcheck)
        .then(response => {
          this.$toast.success("Leak Check completed", {})
          this.leak_check_view = false
        })

    },
    goAddGas () {
      this.removegas = false
      this.addgas = true
    },
    goRemoveGas () {
      this.addgas = false
      this.removegas = true
    },
    addGas () {

      this.fgasadd.asset_id = this.order.asset_id
      this.fgasadd.engineer = this.order.engineer
      this.fgasadd.type = 'Addition'

      axios
        .post('/api/fgas', this.fgasadd)
        .then(response => {
          this.$toast.success("F-Gas Addition completed", {})
          this.addgas = false
        })

    },
    removeGas () {

      this.fgasremove.asset_id = this.order.asset_id
      this.fgasremove.engineer = this.order.engineer
      this.fgasremove.type = 'Removal'

      axios
        .post('/api/fgas', this.fgasremove)
        .then(response => {
          this.$toast.success("F-Gas Removal completed", {})
          this.removegas = false
        })

    },
    deleteJob () {
      if(confirm("Do you really want to delete this job?")){
        axios
          .delete(`/api/orders/${this.$route.params.id}`)
          .then(response => (
            //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
            this.$toast.success("Job deleted", {}),
            this.$router.push({ name: 'Orders', params: { id: this.$route.params.id } })
          ))
          .catch(err => console.log(err))
          // .finally(() => this.loading = false)
      }
    },
    undoSignature() {
      this.$refs.signaturePad.undoSignature();
    },
    updateOrder () {

      /*if (!this.order.engineer_signature_image) {
        const { isEmptyEngineer, dataEngineer } = this.$refs.signaturePadEngineer.saveSignature();
        console.log(isEmptyEngineer);
        console.log(dataEngineer);

        if (!isEmptyEngineer) {
          this.order.engineer_signature_image = dataEngineer;
        }

      }*/

      if (!this.order.signature_image) {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      //console.log(isEmpty);
      //console.log(data);
    
        if (!isEmpty) {

          let dates= new Date()
          let month = dates.getUTCMonth() + 1
          let day = dates.getUTCDate()
          let year = dates.getUTCFullYear()
          let currentDate = year + "-" + month + "-" + day
          
          this.order.signature_image = data;
          this.order.date_signed = currentDate;

          if (this.order.futher_work==="") {
            this.order.status = 'complete';
            this.order.complete_status = 'yes';
          } else {
            this.order.status = 'further';
          }
    
        }

      }

      axios
        .put(`/api/orders/${this.$route.params.id}`, this.order)
        .then(response => (
          //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
          this.$toast.success("Job saved", {}),
          this.$router.push({ name: 'Orders', params: { id: this.$route.params.id } })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    },
    completeOrder () {
      axios
        .put(`/api/orders/${this.$route.params.id}/actions/complete`, this.order)
        .then(response => (
          //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
          this.$toast.success("Job completed", {}),
          this.$router.push({ name: 'Orders', params: { id: this.$route.params.id } })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    },
    uploadImage () {

      console.log('active')
      console.log(this.$refs)

      this.images.file = this.$refs.ecofile.files
      this.images.job_number = this.order.order_number

      axios
        .post(`/api/sharepoint/upload`, this.images, {headers: {"Content-Type": "multipart/form-data"}})
        .then(response => (
          this.$toast.success("Image uploaded", {})
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    },
    invoiceOrder () {
      axios
        .put(`/api/orders/${this.$route.params.id}/actions/invoice`, this.order)
        .then(response => (
          //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
          this.$toast.success("Job invoiced", {}),
          this.$router.push({ name: 'Orders', params: { id: this.$route.params.id } })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
      }
      
  }
}
</script>

<style scoped>
.jobImages {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  margin-top: 15px;
}
.jobImage {
  display: flex;
  flex-direction: column;
  color: inherit;
  text-decoration: none;
  word-break: break-all;
}
.jobImage img {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: 4px;
  background: #f0f0f0;
}
.jobImage small {
  margin-top: 4px;
  opacity: 0.7;
}
.jobImagesNote {
  margin: 15px 0 0;
  opacity: 0.7;
}
</style>
